/**
 * Store Locator JS Functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.store-locator-wrapper');
  if (!container) return;

  // Raw store data passed from Liquid JSON
  let storesData = [];
  const dataScript = document.getElementById('sl-stores-json');
  if (dataScript) {
    try {
      storesData = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Failed to parse stores JSON data', e);
    }
  }

  // DOM Elements
  const productInput = document.getElementById('sl-search-product');
  const cityInput = document.getElementById('sl-search-city');
  const searchBtn = document.getElementById('sl-search-btn');
  const categoryRadios = document.querySelectorAll('input[name="sl-category"]');
  const demoOnlyCheck = document.getElementById('sl-demo-only');
  const storeListContainer = document.getElementById('sl-store-list');
  
  // Drawer Elements
  const drawerBackdrop = document.getElementById('sl-drawer-backdrop');
  const drawer = document.getElementById('sl-drawer');
  const drawerCloseBtn = document.getElementById('sl-drawer-close');
  const drawerStoreName = document.getElementById('sl-drawer-name');
  const drawerAddress = document.getElementById('sl-drawer-address');
  const drawerPhone = document.getElementById('sl-drawer-phone');
  const drawerWebsite = document.getElementById('sl-drawer-website');
  const drawerHours = document.getElementById('sl-drawer-hours');
  const drawerTryGrid = document.getElementById('sl-drawer-try-grid');
  const drawerGalleryGrid = document.getElementById('sl-drawer-gallery-grid');
  const drawerBtnDirections = document.getElementById('sl-drawer-btn-directions');
  const drawerBtnCall = document.getElementById('sl-drawer-btn-call');
  const drawerBtnWebsite = document.getElementById('sl-drawer-btn-website');
  const drawerMapContainer = document.getElementById('sl-drawer-map');

  let activeCategory = 'ALL';

  // Helper to get demo product title (prioritize demo_products_title array at index)
  function getDemoProductTitle(store, prod, idx) {
    if (Array.isArray(store.demo_products_title) && store.demo_products_title[idx]) {
      const customTitle = String(store.demo_products_title[idx]).trim();
      if (customTitle) return customTitle;
    }
    if (typeof prod === 'object' && prod !== null) {
      return prod.title || prod.full_title || '';
    }
    return String(prod || '');
  }

  function normalizeProductSearch(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  // Helper to extract category strings from store item
  function extractCategories(catField) {
    const results = [];
    const walk = (item) => {
      if (item === null || item === undefined) return;
      if (typeof item === 'string' || typeof item === 'number') {
        String(item).split(/[,/|;]+/).forEach(str => {
          const cleaned = str.trim();
          if (cleaned) results.push(cleaned.toUpperCase());
        });
      } else if (Array.isArray(item)) {
        item.forEach(walk);
      } else if (typeof item === 'object') {
        if (item.name) walk(item.name);
        if (item.handle) walk(item.handle);
        if (item.title) walk(item.title);
        if (item.label) walk(item.label);
        if (item.value) walk(item.value);
        if (item.system && item.system.handle) walk(item.system.handle);
      }
    };
    walk(catField);
    return results;
  }

  // Auto discover categories in storesData and append missing radio items to UI
  const radioGroupContainer = document.querySelector('.sl-radio-group');
  if (radioGroupContainer && Array.isArray(storesData)) {
    const getExistingRadios = () => Array.from(document.querySelectorAll('input[name="sl-category"]'));
    const existingVals = getExistingRadios().map(r => r.value.toUpperCase());

    const discoveredCats = new Set();
    storesData.forEach(store => {
      extractCategories(store.category).forEach(c => discoveredCats.add(c));
    });

    discoveredCats.forEach(cat => {
      if (cat && !existingVals.includes(cat)) {
        const label = document.createElement('label');
        label.className = 'sl-radio-item';
        label.innerHTML = `
          <input type="radio" name="sl-category" value="${escapeHtml(cat)}" />
          <span>${escapeHtml(cat)}</span>
        `;
        radioGroupContainer.appendChild(label);
        existingVals.push(cat);
      }
    });
  }

  // Filter Trigger
  function filterStores() {
    const checkedRadio = document.querySelector('input[name="sl-category"]:checked');
    if (checkedRadio) {
      activeCategory = checkedRadio.value;
    }

    const productQuery = normalizeProductSearch(productInput ? productInput.value.trim() : '');
    const cityQuery = (cityInput ? cityInput.value : '').trim().toLowerCase();
    const isDemoOnly = demoOnlyCheck ? demoOnlyCheck.checked : false;

    const filtered = storesData.filter(store => {
      // 1. Category Filter
      if (activeCategory && activeCategory.toUpperCase() !== 'ALL') {
        const categories = extractCategories(store.category);
        const targetCat = activeCategory.trim().toUpperCase();
        const targetSingular = targetCat.replace(/S$/, '');

        const isMatched = categories.some(cat => {
          const catSingular = cat.replace(/S$/, '');
          return cat === targetCat || 
                 catSingular === targetSingular || 
                 cat.includes(targetCat) || 
                 targetCat.includes(cat);
        });

        if (!isMatched) {
          return false;
        }
      }

      // 2. Demo Only Filter
      if (isDemoOnly && !store.has_demo) {
        return false;
      }

      // 3. Product Search Filter
      if (productQuery) {
        let demoProdsText = '';
        if (Array.isArray(store.demo_products)) {
          demoProdsText = store.demo_products.map((prod, idx) => {
            const title = getDemoProductTitle(store, prod, idx);
            const fullTitle = (typeof prod === 'object' && prod !== null && prod.full_title) ? prod.full_title : '';
            return `${title} ${fullTitle}`;
          }).join(' ');
        } else if (typeof store.demo_products === 'string') {
          demoProdsText = store.demo_products;
        }
        if (Array.isArray(store.demo_products_title)) {
          demoProdsText += ' ' + store.demo_products_title.join(' ');
        }
        if (!normalizeProductSearch(demoProdsText).includes(productQuery)) {
          return false;
        }
      }

      // 4. City / Dealer Search Filter
      if (cityQuery) {
        const nameMatch = (store.name || '').toLowerCase().includes(cityQuery);
        const cityMatch = (store.city || '').toLowerCase().includes(cityQuery);
        const addrMatch = (store.address || '').toLowerCase().includes(cityQuery);
        if (!nameMatch && !cityMatch && !addrMatch) {
          return false;
        }
      }

      return true;
    });

    renderStoreList(filtered);
  }

  // Render Store Cards
  function renderStoreList(list) {
    if (!storeListContainer) return;

    if (list.length === 0) {
      storeListContainer.innerHTML = `
        <div style="text-align: center; padding: 50px 20px; color: #777;">
          <p style="font-size: 16px; font-weight: 700;">NO DEALERS FOUND MATCHING YOUR CRITERIA.</p>
        </div>
      `;
      return;
    }

    storeListContainer.innerHTML = list.map(store => {
      const demoProductsHtml = (store.demo_products || []).map((prod, idx) => {
        const title = getDemoProductTitle(store, prod, idx);
        return `<span class="sl-tag">${escapeHtml(title)}</span>`;
      }).join('');

      const mediaHtml = store.image
        ? `<img src="${store.image}" alt="${escapeHtml(store.name)}" loading="lazy" />`
        : `<div class="sl-map-placeholder">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
              <circle cx="12" cy="9" r="2.5"/>
            </svg>
           </div>`;

      return `
        <div class="sl-store-card" data-store-id="${store.id}">
          <div class="sl-card-media">
            ${mediaHtml}
          </div>
          <div class="sl-card-info">
            <div class="sl-card-header">
              <h3 class="sl-store-name">${escapeHtml(store.name)}</h3>
              ${store.is_official !== false ? `
                <div class="sl-badge-official">
                  <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                  AUTHORIZED DONNER PARTNER
                </div>
              ` : ''}
            </div>
            
            <div class="sl-card-details">
              <div class="sl-detail-item">
                <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
                <span>${escapeHtml(store.address || '')}</span>
              </div>
              ${store.hours ? `
                <div class="sl-detail-item">
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <span>${escapeHtml(store.hours)}</span>
                </div>
              ` : ''}
            </div>

            ${(store.demo_products && store.demo_products.length > 0) ? `
              <div class="sl-try-section">
                <div class="sl-try-label">AVAILABLE TO TRY</div>
                <div class="sl-try-tags">
                  ${demoProductsHtml}
                </div>
              </div>
            ` : ''}

            <button class="sl-btn-details" data-action="open-drawer" data-store-id="${store.id}">
              VIEW DETAILS
            </button>
          </div>
        </div>
      `;
    }).join('');

    // Bind event for details button
    storeListContainer.querySelectorAll('[data-action="open-drawer"]').forEach(btn => {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-store-id');
        const selectedStore = storesData.find(s => String(s.id) === String(id));
        if (selectedStore) {
          openDrawer(selectedStore);
        }
      });
    });
  }

  // Open Drawer with store details
  function openDrawer(store) {
    if (!drawer || !drawerBackdrop) return;

    if (drawerStoreName) drawerStoreName.textContent = store.name || '';
    if (drawerAddress) drawerAddress.textContent = store.address || '';
    
    if (drawerPhone) {
      const phoneVal = (store.phone || '').trim();
      const phoneRow = drawerPhone.closest('.sl-info-row');
      if (phoneVal) {
        drawerPhone.textContent = phoneVal;
        if (phoneRow) phoneRow.style.display = '';
      } else {
        if (phoneRow) phoneRow.style.display = 'none';
      }
    }

    if (drawerWebsite) {
      const websiteVal = (store.website || '').trim();
      const websiteRow = drawerWebsite.closest('.sl-info-row');
      if (websiteVal) {
        drawerWebsite.textContent = websiteVal.replace(/^https?:\/\//, '');
        drawerWebsite.href = websiteVal;
        if (websiteRow) websiteRow.style.display = '';
      } else {
        if (websiteRow) websiteRow.style.display = 'none';
      }
    }

    if (drawerHours) drawerHours.textContent = store.hours || 'N/A';

    // Render Try products in Drawer
    if (drawerTryGrid) {
      if (store.demo_products && store.demo_products.length > 0) {
        drawerTryGrid.innerHTML = store.demo_products.map((prod, idx) => {
          const title = getDemoProductTitle(store, prod, idx);
          const url = typeof prod === 'object' ? prod.url : '#';
          const img = (typeof prod === 'object' && prod.image) ? prod.image : null;

          const imgHtml = img
            ? `<img src="${img}" alt="${escapeHtml(title)}" loading="lazy" />`
            : `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#aaa" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
               </svg>`;

          return `
            <a href="${url}" class="sl-try-card" style="text-decoration:none; display:block;">
              <div class="sl-try-card-img">
                ${imgHtml}
              </div>
              <div class="sl-try-card-title">${escapeHtml(title)}</div>
            </a>
          `;
        }).join('');
      } else {
        drawerTryGrid.innerHTML = '<div style="color:#999; font-size:12px;">NO DEMO PRODUCTS</div>';
      }
    }

    // Render Gallery in Drawer
    if (drawerGalleryGrid) {
      if (store.gallery && store.gallery.length > 0) {
        drawerGalleryGrid.innerHTML = store.gallery.map(imgUrl => `
          <div class="sl-gallery-item">
            <img src="${imgUrl}" alt="Gallery image" loading="lazy" />
          </div>
        `).join('');
      } else {
        drawerGalleryGrid.innerHTML = '<div style="color:#999; font-size:12px;">NO GALLERY IMAGES</div>';
      }
    }

    // Action Buttons
    let mapsUrl = store.google_maps_url;
    if (!mapsUrl) {
      let destination = '';
      if (store.latitude && store.longitude) {
        destination = `${store.latitude},${store.longitude}`;
      } else {
        destination = [store.name, store.address, store.city].filter(Boolean).join(', ');
      }
      mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
    }
    if (drawerBtnDirections) drawerBtnDirections.href = mapsUrl;
    if (drawerBtnCall) {
      const phoneVal = (store.phone || '').trim();
      if (phoneVal) {
        drawerBtnCall.href = `tel:${phoneVal.replace(/[^\d+]/g, '')}`;
        drawerBtnCall.style.display = '';
      } else {
        drawerBtnCall.style.display = 'none';
      }
    }
    if (drawerBtnWebsite) {
      const websiteVal = (store.website || '').trim();
      if (websiteVal) {
        drawerBtnWebsite.href = websiteVal;
        drawerBtnWebsite.style.display = '';
      } else {
        drawerBtnWebsite.style.display = 'none';
      }
    }

    // Show Drawer
    drawerBackdrop.classList.add('is-active');
    drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // Render Map in Drawer if lat/lng available or Leaflet present
    initDrawerMap(store);
  }

  function closeDrawer() {
    if (!drawer || !drawerBackdrop) return;
    drawerBackdrop.classList.remove('is-active');
    drawer.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function initDrawerMap(store) {
    if (!drawerMapContainer) return;

    const rawLat = parseFloat(store.latitude);
    const rawLng = parseFloat(store.longitude);
    let query = '';

    if (Number.isFinite(rawLat) && Number.isFinite(rawLng)) {
      query = `${rawLat},${rawLng}`;
    } else {
      const addr = (store.address || '').trim();
      const city = (store.city || '').trim();
      if (addr && city && !addr.toLowerCase().includes(city.toLowerCase())) {
        query = `${addr}, ${city}`;
      } else {
        query = addr || city || (store.name || '').trim();
      }
    }

    if (!query) {
      drawerMapContainer.innerHTML = `
        <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#e2e5e8;color:#555;font-weight:700;font-size:12px;text-align:center;padding:10px;">
          📍 MAP PREVIEW
        </div>
      `;
      return;
    }

    const lang = (document.documentElement.lang || navigator.language || '').trim();
    const hlParam = lang ? `&hl=${encodeURIComponent(lang)}` : '';
    const embedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(query)}${hlParam}&z=14&output=embed`;

    drawerMapContainer.innerHTML = `
      <iframe
        src="${embedUrl}"
        title="${escapeHtml(store.name || 'Store Map')}"
        style="width:100%;height:100%;border:0;display:block;"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen>
      </iframe>
    `;
  }

  // Utility to escape HTML
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Event Listeners
  if (searchBtn) {
    searchBtn.addEventListener('click', filterStores);
  }

  if (productInput) {
    productInput.addEventListener('keyup', function (e) {
      if (e.key === 'Enter') filterStores();
    });
  }

  if (cityInput) {
    cityInput.addEventListener('keyup', function (e) {
      if (e.key === 'Enter') filterStores();
    });
  }

  if (radioGroupContainer) {
    radioGroupContainer.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'sl-category') {
        activeCategory = e.target.value;
        filterStores();
      }
    });
  }

  document.querySelectorAll('input[name="sl-category"]').forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        activeCategory = this.value;
        filterStores();
      }
    });
  });

  if (demoOnlyCheck) {
    demoOnlyCheck.addEventListener('change', filterStores);
  }

  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', closeDrawer);
  }

  if (drawerBackdrop) {
    drawerBackdrop.addEventListener('click', closeDrawer);
  }

  // Initial Render
  renderStoreList(storesData);
});
